import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes } from '../global/constants';
import { mediaQueryString } from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

;(function($) {
	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Variables ----------

		let mobileAnimations = [];
		let menuAnimations = [];
		let desktopAnimations = [];
		let globalAnimations = [];

		// ---------- Animated Section ----------

		$('.animated-section:not(.transition-clone)').each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						once: true,
						start: 'top 70%',
						toggleClass: Classes.active,
					}
				});
			});
		});

		// ---------- Parallax Sections ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

			desktopAnimations.push(() => {

				const image = this.querySelector(':scope .section-image');
				const speed = 25;

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
						},
					});

					timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
				}
			});
		});

		$('.home-links-section').each(function() {

			desktopAnimations.push(() => {

				const leftImages = this.querySelectorAll(':scope .content-column:nth-child(odd)');
				const rightImages = this.querySelectorAll(':scope .content-column:nth-child(even)');
				const speed = 15;

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				if(leftImages) {
					timeline.to(leftImages, { yPercent: -speed, ease: 'none' }, 0);
				}

				if(rightImages) {
					timeline.to(rightImages, { yPercent: speed, ease: 'none' }, 0);
				}
			});
		});

		$('.texts-images-section').each(function() {

			menuAnimations.push(() => {

				const content = this.querySelectorAll(':scope .text-column');
				const speed = 20;

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				if(content) {
					timeline.fromTo(content, { yPercent: speed }, { yPercent: -speed, ease: 'none' });
				}
			});
		});

		// ---------- CTAs Fade-in ----------

		$('.hero-visite-section').each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: '50% 56%',
						endTrigger: 'footer',
						end: 'bottom top',
						toggleClass: {
							targets: $('.widget-column'),
							className: Classes.show
						},
					}
				});
			});
		});

		// ---------- CTAs Fade-out-down Desktop ----------

		$(' .reviews-section').each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						endTrigger: 'footer',
						end: 'bottom top',
						// markers: true,
						toggleClass: {
							targets: $('.widget-column'),
							className: Classes.fadeDown
						},
					}
				});
			});
		});


		// ---------- CTAs Fade-out Mobile ----------

		$('footer').each(function() {

			mobileAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: '99% bottom',
						// markers: true,
						toggleClass: {
							targets: $('.widget-column'),
							className: Classes.fadeDown
						},
					}
				});
			});
		});

		// ---------- Animated header-wrapper ---------

		$Elements.HeaderWrapper.each(function() {

			globalAnimations.push(() => {

				gsap.timeline({
					scrollTrigger: {
						start: 1,
						end: 'max',
						onUpdate: (self) => {
							(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
							(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
						}
					}
				});
			});
		});

		// ---------- Handle Media Queries ----------

		ScrollTrigger.matchMedia({

			// Desktop Animations
			[mediaQueryString(Breakpoints.Mobile)]: () => desktopAnimations.map(animation => animation()),

			// Menu Animations
			[mediaQueryString(Breakpoints.Menu)]: () => menuAnimations.map(animation => animation()),

			// Mobile Animations
			[mediaQueryString(Breakpoints.Mobile, false)]: () => mobileAnimations.map(animation => animation()),

			// Global Animations
			'all': () => globalAnimations.map(animation => animation()),

		});
	});

}(jQuery));
